import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Form, Input, Select, Button } from "antd";
import backArrow from "../../../Assets/Images/back-arrow.svg";
import { userServices } from "../../../Services/API/userServices";
import { toast } from "react-toastify";
import { sessionServices } from "../../../Utils/SessionServices";
import { validatePhoneNumber } from "../../../Utils/phoneNumberValidation";
import Loader from "../../../Components/Loader/Loader";

export default function FundraisersForm() {
  const navigate = useNavigate();
  const location = useLocation();
  const action = location?.state?.action;
  const state = location?.state?.data;
  const [form] = Form.useForm();
  const [loader, setLoader] = useState(false);
  const [dropdownDisable, setDropDownDisable] = useState(false);

  const [gsaList, setGsaList] = useState([]);

  useEffect(() => {
    getAllGsaList();
  }, []);

  const getAllGsaList = async (showLoader = true) => {
    try {
      setLoader(true);
      const accessToken = await sessionServices?.getSessionStorageItem("token");
      const currentRole = await sessionServices?.getSessionStorageItem("role");

      if (currentRole === "GSA") {
        setDropDownDisable(true);
      }

      const resp =
        currentRole === "ADMIN"
          ? await userServices.getUserBasedOnRole(accessToken, "GSA")
          : await userServices.getCurrentUser(accessToken);

      let gsaListArray = [];
      if (resp?.data?.length) {
        gsaListArray = resp?.data?.map((item) => ({
          label: `${item?.firstName} - (${item?.email})`,
          value: item?.email,
          fullName: `${item?.firstName} ${item?.lastName}`,
          requiredPayloadName: `${item?.firstName} ${item?.lastName} | ${item?.email}`,
        }));
      } else {
        gsaListArray = [
          {
            label: `${resp?.data.displayName.split("/")[0]}- (${
              resp?.data?.email
            })`,
            value: resp?.data?.email,
            fullName: `${resp?.data?.displayName?.split("/")[0]}${resp?.data?.displayName?.split("/")[1] || ''}`,
            requiredPayloadName: `${resp?.data?.displayName?.split("/")[0]}${resp?.data?.displayName?.split("/")[1]} | ${resp?.data?.email}`,
            disabled: true,
          },
        ];
      }
      form.setFieldsValue({
        firstName: state?.firstName || "",
        lastName: state?.lastName || "",
        gsa:
          currentRole === "GSA"
            ? gsaListArray[0]?.value
            : gsaListArray?.find((item) => item?.value === state?.gsa)?.value,
        club: state?.club || "",
        phoneNumber: state?.phoneNo?.slice(2),
        email: state?.email,
      });
      setGsaList(gsaListArray);
    } catch (error) {
      console.log("err", error);
    } finally {
      setLoader(false);
    }
  };

  const onSaveClick = async (values) => {
    try {
      const payload = {
        email: values?.email || '',
        phoneNo: `${values?.phoneNumber}`,
        userType: "HERO",
        firstName: values?.firstName || '',
        lastName: values?.lastName || '',
        gsa:
          `${gsaList?.find((item) => item?.value == values?.gsa).fullName} | ${
            values?.gsa
          }` ||
          gsaList?.find((item) => item?.value === values?.GSA)
            ?.requiredPayloadName || '',
        club: values?.club || '',
        location: values?.location,
        ...(action === "edit" && { uid: state?.uid }),
      };
      const response =
        action === "edit"
          ? await userServices?.updateUser(payload)
          : await userServices.createUser(payload);
      if (response?.data) {
        toast.success(
          action === "edit" ? "Updated successfully" : "Created successfully"
        );
        navigate("/");
      }
    } catch (error) {
      console.log("error", error);
      toast.error(
        `${
          error?.response?.data?.message ||
          error?.response?.data ||
          "Sorry something went wrong"
        }`
      );
    }
  };

  return (
    <>
      {loader ? (
        <div style={{ height: "80vh" }}>
          <Loader />
        </div>
      ) : (
        <div className="form-page">
          <div className="forms-header-component">
            <div className="back-btn-container">
              <img
                src={backArrow}
                className="back-arrow"
                onClick={() => navigate("/")}
                alt="Back to Fundraisers Hero"
              />
            </div>
            <div className="heading-container">
              {action === "add"
                ? "Add New Fundraiser Hero"
                : `Edit - Fundraiser Hero - ${state?.firstName} `}
            </div>
          </div>
          <div className="fundraiser-form-component">
            <div className="form-container">
              <Form
                form={form}
                className="form-component"
                labelCol={{
                  span: 8,
                }}
                colon={false}
                onFinish={onSaveClick}
              >
                <Form.Item
                  className="form-item"
                  label={<div className="form-label">First Name:</div>}
                  name="firstName"
                  rules={[{ required: true, message: "Enter First Name" }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  className="form-item"
                  label={<div className="form-label">Last Name:</div>}
                  name="lastName"
                  rules={[{ required: true, message: "Enter Last Name" }]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  className="form-item"
                  label={<div className="form-label">GSA:</div>}
                  name="gsa"
                  rules={[
                    { required: true, message: "Please select gsa name" },
                  ]}
                >
                  <Select
                    disabled={dropdownDisable}
                    value={gsaList[0]?.label}
                    onChange={(val) => {}}
                    options={gsaList}
                  />
                </Form.Item>
                <Form.Item
                  className="form-item"
                  label={<div className="form-label">Club/Organisation:</div>}
                  name="club"
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  className="form-item"
                  label={<div className="form-label">Phone Number:</div>}
                  name="phoneNumber"
                  rules={[
                    { required: true, message: "Please enter phone number" },
                    ({ getFieldValue }) => ({
                      validator: validatePhoneNumber,
                    }),
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  className="form-item"
                  label={<div className="form-label">Email ID:</div>}
                  name="email"
                  rules={[
                    {
                      required: true,
                      type: "email",
                      message: "Please enter a valid email!",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Form>
            </div>
          </div>
          <div className="forms-btns-container">
            <Button className="save-btn" onClick={() => form.submit()}>
              Save
            </Button>
            <Button className="cancel-btn" onClick={() => navigate("/")}>
              Cancel
            </Button>
          </div>
        </div>
      )}
    </>
  );
}
